import { reportCaption } from "../../utils/report-caption";
import { reportBackgroundColor } from "../../utils/report-color";
// @ts-ignore
import filedlogo from "../../../../../public/assets/icons/logofilled.png";
import { ServiceType } from "@agroyaar/sdk";

interface FooterProps {
  serviceType: ServiceType;
  pageNumber: number;
  reportCode?: string;
}

const Footer = ({ serviceType, reportCode, pageNumber }: FooterProps) => {
  const footerCaption = reportCaption(reportCode);

  const reportBackground = reportBackgroundColor(serviceType);

  return (
    <div className="  w-full flex flex-col items-center justify-end gap-[2rem]">
      <div className="relative w-full h-[72px] flex">
        <span
          className="absolute bottom-0 left-0 w-full h-[48px] rounded-br-[60rem] blur-[1px] rotate-180"
          style={{ background: reportBackground }}
        />
        <p className="absolute font-IransansX bottom-[16px] right-[64px] text-white font-semibold text-[10px]">
          {footerCaption}
        </p>
        <p className="absolute font-IransansX bottom-[8px] right-[16px] text-white font-extrabold text-[16px] m-0">
          {pageNumber}
        </p>

        <div
          className="absolute top-0 left-[32px] flex items-center gap-[32px] p-[4px_14px] rounded-[10px] border border-[rgba(255,255,255,0.6)] glassshadow"
          style={{
            background:
              "linear-gradient(135deg,rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.17) 100%)",
            borderImage: "linear-gradient(313deg, #E1E1E1, #ffffff40)",
          }}
        >
          <span className="text-[#028442] text-[26px] font-extrabold">
            پلتفرم جامع خدمات کشاورزی اگرویار
          </span>
          <div className="flex items-center gap-[8px]">
            <img src={filedlogo} alt="logo" className="h-[40px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
